import { useOrganization } from "@/api/services/admin/organization";
import { LoadingPage } from "@/modules/irohana-components/elements/Loading/Loading";
import { OrganizationForm } from "@/features/organization/components/OrganizationForm";
import { convertOrganizationResToForm } from "@/features/organization/utils/converts";
import { AppRoutes } from "@/routes/config";
import { isNumber } from "@/utils/number";
import { getDynamicRoute } from "@/utils/url";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

const OrganizationEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data, isLoading, isError } = useOrganization();
  const org = data?.data;

  useEffect(() => {
    if (!id || !isNumber(id)) {
      navigate(AppRoutes.organizationList, { replace: true });
    }
  }, [id, navigate]);

  useEffect(() => {
    if (id && isNumber(id) && !isLoading && (isError || !org)) {
      navigate(AppRoutes.organizationList, { replace: true });
    }
  }, [id, isLoading, isError, org, navigate]);

  if (isLoading || !org) return <LoadingPage />;

  return (
    <OrganizationForm previousData={convertOrganizationResToForm(org)} backUrl={getDynamicRoute(AppRoutes.organizationDetail, { id: org.id })} />
  );
};

export default OrganizationEdit;
